function isEmpty(value) {
  if (value === null || value === void 0) {
    return true;
  }
  if (typeof value === "string" || Array.isArray(value)) {
    return value.length === 0;
  }
  if (value instanceof Map || value instanceof Set) {
    return value.size === 0;
  }
  if (typeof value === "object") {
    return Object.keys(value).length === 0;
  }
  return true;
}
export {
  isEmpty
};
//# sourceMappingURL=is-empty.js.map
